<!--
~ Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
-->
<bci-master-detail-view
  [closeTrigger]="closeTrigger"
  [useDialog]="false"
  [useSlideoverSidebarMode]="useSlideoverSidebarMode"
>
  <bci-master-view>
    <h2 class="page-heading">{{ 'siteMaster.title' | translate }}</h2>

    <div class="site-master-table-container">
      <mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="siteId" *ngIf="hasPermission">
          <mat-header-cell *matHeaderCellDef>{{
            'siteMaster.SiteID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let site"
            ><a id="col-siteId" (click)="goToSiteSetUp($event, site.siteId)">{{
              site.siteId
            }}</a></mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="siteId" *ngIf="!hasPermission">
          <mat-header-cell *matHeaderCellDef>{{
            'siteMaster.SiteID' | translate
          }}</mat-header-cell>

          <mat-cell *matCellDef="let site">{{ site.siteId }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="siteName">
          <mat-header-cell *matHeaderCellDef [ngClass]="'customWidthClass'">{{
            'siteMaster.SiteName' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let site" [ngClass]="'customWidthClass'">{{
            site.siteName
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="industryType">
          <mat-header-cell *matHeaderCellDef class="headerNotWordBreak">{{
            'siteMaster.IndustryType' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let site">{{ site.industryType }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="city">
          <mat-header-cell *matHeaderCellDef>{{
            'siteMaster.City' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let site">{{ site.city }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="contactPersonName">
          <mat-header-cell *matHeaderCellDef>{{
            'siteMaster.Contact' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let site">{{
            site.contactPersonName
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="executionState">
          <mat-header-cell *matHeaderCellDef class="headerNotWordBreak">{{
            'siteMaster.ExecutionState' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let site">{{ site.executionState }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>{{
            'siteMaster.Status' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let site"
            ><div
              class="oval"
              [ngClass]="getSensorHealth(site.sensorHealth)"
            ></div
          ></mat-cell>
        </ng-container>

        <ng-container matColumnDef="clickHere">
          <mat-header-cell *matHeaderCellDef>{{
            'siteMaster.Dashboard' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let site"
            ><a id="clickhereId" (click)="goToSite($event, site.siteId)">{{
              'siteMaster.Click' | translate
            }}</a></mat-cell
          >
        </ng-container>

        <ng-container *ngIf="VIEW_PER">
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row
            *matRowDef="let site; columns: displayedColumns"
            [routerLink]="['.', site.siteId]"
          ></mat-row>
        </ng-container>

        <ng-container *ngIf="!VIEW_PER">
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let site; columns: displayedColumns"></mat-row>
        </ng-container>
      </mat-table>

      <div #paginator class="paginator">
        <button
          bciprimarybutton
          [disabled]="siteMasterService.currentPage === 0"
          [routerLink]="['.']"
          [queryParams]="{ page: 0 }"
        >
          <mat-icon fontIcon="bosch-ic-back-left-double"></mat-icon>
        </button>
        <button
          bciprimarybutton
          [disabled]="siteMasterService.currentPage === 0"
          [routerLink]="['.']"
          [queryParams]="{ page: siteMasterService.currentPage - 1 }"
        >
          <mat-icon fontIcon="bosch-ic-back-left"></mat-icon>
        </button>
        <span *ngFor="let page of siteMasterService.pages">
          <button
            bciprimarybutton
            [routerLink]="['.']"
            [queryParams]="{ page: page.index }"
            [class.selected]="page.active"
            (click)="siteMasterService.currentPage = page.index"
          >
            {{ page.index + 1 }}
          </button>
        </span>
        <button
          bciprimarybutton
          [disabled]="
            siteMasterService.currentPage >= siteMasterService.pageCount - 1
          "
          [routerLink]="['.']"
          [queryParams]="{ page: siteMasterService.currentPage + 1 }"
        >
          <mat-icon fontIcon="bosch-ic-forward-right"></mat-icon>
        </button>
        <button
          bciprimarybutton
          [disabled]="
            siteMasterService.currentPage >= siteMasterService.pageCount - 1
          "
          [routerLink]="['.']"
          [queryParams]="{ page: siteMasterService.pageCount - 1 }"
        >
          <mat-icon fontIcon="bosch-ic-forward-right-double"></mat-icon>
        </button>
      </div>
    </div>
  </bci-master-view>

  <!-- Detail -->
  <bci-detail-view [isPadded]="true">
    <router-outlet></router-outlet>
  </bci-detail-view>
</bci-master-detail-view>
